
import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { configs } from '@constants/configs/configs';


export const useTitle = (initialValue = '', data) => {

    const [title, toggleTitle] = useState(initialValue);

    const {
        adjustedFlow,
        exchangeName,
        page,
        pathname,
        language,
        loadedLanguages = []
    } = data;

    const intlApi = useIntl();
    let newTitle;
    let isDefaultTitle = false;

    const intlSsapPageName = () => {
        return adjustedFlow[page] ? `${intlApi.formatMessage({ id: adjustedFlow[page].page.navBarText })} - ` + `${intlApi.formatMessage({ id: 'pageTitle.ssap_application' })} - ${exchangeName}` : exchangeName;
    };

    const getDefaultPageTitle = () => {
        const h1Text = document.querySelector('h1')?.textContent?.trim();
        return h1Text ? `${h1Text} - ${exchangeName}` : exchangeName;
    };

    useEffect(() => {
        let matchedPathname = pathname;
        if (pathname?.startsWith(`${configs.routes.CAP_MEMBER_HISTORICAL_DOCUMENTS}/`)) {
            matchedPathname = configs.routes.CAP_MEMBER_HISTORICAL_DOCUMENTS;
        } else if (pathname?.startsWith(`${configs.routes.CAP_MEMBER_HISTORICAL_NOTICES}/`)) {
            matchedPathname = configs.routes.CAP_MEMBER_HISTORICAL_NOTICES;
        }

        switch (matchedPathname) {
            case configs.routes.HOME:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.home' }, { exchangeName })}`;
                break;
            case configs.routes.ACCESS_CODE:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.accessCode' }, { exchangeName })}`;
                break;
            case configs.routes.INDPORTAL:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.dashboard' }, { exchangeName })}`;
                break;
            case configs.routes.APPLICATIONS:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.applications' }, { exchangeName })}`;
                break;
            case configs.routes.ELIGIBILITY_RESULTS:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.eligibilityresults' }, { exchangeName })}`;
                break;
            case configs.routes.COMMUNICATION_PREFERENCES:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.preferences' }, { exchangeName })}`;
                break;
            case configs.routes.NEW_INBOX_HOME:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.myinbox' }, { exchangeName })}`;
                break;
            case configs.routes.HISTORICAL_DOCUMENTS:
            case configs.routes.CAP_MEMBER_HISTORICAL_DOCUMENTS:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.historicalDocuments' }, { exchangeName })}`;
                break;
            case configs.routes.HISTORICAL_NOTICES:
            case configs.routes.CAP_MEMBER_HISTORICAL_NOTICES:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.historicalNotices' }, { exchangeName })}`;
                break;
            case configs.routes.COMMUNICATION_PREFERENCES_AC:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.preferences_ac' }, { exchangeName })}`;
                break;
            case configs.routes.TICKET_CONSUMER:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.tickets' }, { exchangeName })}`;
                break;
            case configs.routes.TICKET_CONSUMER_DETAIL:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.tickets_details' }, { exchangeName })}`;
                break;
            case configs.routes.TICKET_LIST:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.manage_tickets' }, { exchangeName })}`;
                break;
            case configs.routes.VERIFICATION_DOCUMENTS:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.qle' }, { exchangeName })}`;
                break;
            case configs.routes.FORGOT_EMAIL:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.forgot_email' }, { exchangeName })}`;
                break;
            case configs.routes.DELEGATION_CONSUMER:
                newTitle = `${intlApi.formatMessage({ id: 'pageTitle.delegates' }, { exchangeName })}`;
                break;
            case configs.routes.SSAP:
                newTitle = intlSsapPageName();
                break;
            default:
                isDefaultTitle = true;
                newTitle = getDefaultPageTitle();
        }

        const updateTitle = () => {
            toggleTitle(isDefaultTitle ? getDefaultPageTitle() : newTitle);
        };

        // Mutation observer is used to keep the track of h1 in case of lazy loading or any other delay in rendering the component
        updateTitle();
        if (isDefaultTitle) {
            const observer = new MutationObserver(updateTitle);
            observer.observe(document.body, { childList: true, subtree: true });
            return () => observer.disconnect();
        }

    }, [page, adjustedFlow.length, language, pathname, loadedLanguages.length]);

    useEffect(() => {
        document.title = title;
    }, [title]);
};
